import { PostalCode } from '../models/common/postalCode';

export const checkIfPostalCode = (text: string, market?: string) => {
  if (market) {
    const regex = new RegExp(PostalCode[market as keyof typeof PostalCode]);
    return regex.test(text);
  }
  return false;
};
